import { FC } from "react";
import { Paper, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import CarbonSnapMap from "../../shared/components/CarbonSnapMap";
import { CarbonSnapResultsResponse } from "../../../../../datasources/carbonsnap/io/response";

interface Props {
	route: CarbonSnapResultsResponse["route"];
}

const ResultsMapSection: FC<Props> = ({ route }) => {
	const { t } = useTranslation("feature.carbonsnap");

	return (
		<Paper sx={{ p: 3 }}>
			<Typography variant="h6" sx={{ mb: 2 }}>
				{t("results/map/title") || "Mappa Percorso"}
			</Typography>
			<Box sx={{ height: 500, width: "100%" }}>
				<CarbonSnapMap nodes={route.nodes} arcs={route.arcs} />
			</Box>
		</Paper>
	);
};

export default ResultsMapSection;
